import React, { useEffect, useState } from 'react';

export default function MaintenancePage() {
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');

  useEffect(() => {
    fetch('/maintenanceConfig.json')
      .then((res) => res.json())
      .then((data) => {
        setStart(data.startDate);
        setEnd(data.endDate);
      })
      .catch(() => {});
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f3f4f6',
      margin: 0,
      padding: 0,
      fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
      textAlign: 'center',
    }}>
      <div style={{
        backgroundColor: '#fff',
        padding: '2rem',
        borderRadius: 16,
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
        maxWidth: 500,
        width: '90%',
      }}>
        <h1 style={{ fontSize: '2rem', marginBottom: '1rem', color: 'red', fontWeight: 'bold' }}>Scheduled Maintenance</h1>
        <p style={{ fontSize: '1rem', color: '#4b5563', margin: '0.5rem 0' }}>
          We are currently performing scheduled maintenance on <strong>ePay</strong>.
        </p>
        <p style={{ fontSize: '1rem', color: '#4b5563', margin: '0.5rem 0' }}>
          The service will be <strong>unavailable from</strong>
          <br />
          <strong style={{ color: '#ff6666' }}>{start || '...'}</strong>
          <br />
          <strong style={{ color: '#ff6666' }}>until {end || '...'}</strong>.
        </p>
        <p style={{ fontSize: '0.875rem', color: '#6b7280', marginTop: '1.5rem' }}>
          We appreciate your patience and apologize for any inconvenience.
        </p>
      </div>
    </div>
  );
} 